import React from 'react';
  
function Home (){
    return (
        <div>
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            <div className="content">    
                <h1 className="home-content">NBCU</h1>
            </div>
            <div className="renew-content">
                <div className="waviy">
                    <span className="--i:1">R</span>
                    <span className="--i:2">e</span>
                    <span className="--i:3">n</span>
                    <span className="--i:4">e</span>
                    <span className="--i:5">w</span>
                </div>
            </div>
        </div>
    )
}
  
export default Home;